
export class ExerciseMaterial {
    filename?: string;
    path?: number;
    mime?: string;
    size?: string;

    static fromJson(fields: any): ExerciseMaterial {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
